import React, { useState } from 'react';
import PropTypes from 'prop-types';

import IconMuteOn from './svg/IconMuteOn';
import IconMuteOff from './svg/IconMuteOff';

function MuteButton() {
  const [active, setActive] = useState(false);
  const onClick = () => {
    if (window['YouDJ'] && window['YouDJ'].master_volume) { 
      window['YouDJ'].master_volume(!active ? 0 : 100); 
    }
    setActive(!active);
  }
  return (
    <div className={`align`} onClick={onClick} >
      { active 
        ?  <IconMuteOn className={`cf-icon-fill-v2`} />
        :  <IconMuteOff className={`cf-icon-fill-v2`} color={'#8E8E93'} />
      }
    </div>
  )
}

MuteButton.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export default MuteButton;
